<script lang="ts">
    import type {PdfjsModule} from '../types';
    import type * as Pdfjs from 'pdfjs-dist/types/src/pdf';
    import {onMount} from 'svelte';
    import {MvPdfLinkManager} from './mv-pdf-link.manager';
    import {getViewedContentContext} from '../../../../lib/mv-viewed-content';
    import {MvDownloadManager} from './mv-download.manager';

    export let pdfDocument: Pdfjs.PDFDocumentProxy;
    export let page: Pdfjs.PDFPageProxy;
    export let pages: Pdfjs.PDFPageProxy[];
    export let viewport: Pdfjs.PageViewport;
    export let module: PdfjsModule;

    const viewedContent = getViewedContentContext();

    let annotations: any[];
    let annotationLayerElement: HTMLDivElement;
    let annotationLayer: Pdfjs.AnnotationLayer;

    onMount(async () => {
        annotations = await page.getAnnotations();

        annotationLayer = new module.AnnotationLayer({
            div: annotationLayerElement,
            structTreeLayer: null,
            accessibilityManager: null,
            annotationCanvasMap: null,
            annotationEditorUIManager: null,
            page,
            viewport
        });

        await annotationLayer.render({
            annotations,
            div: annotationLayerElement,
            page,
            viewport,
            linkService: new MvPdfLinkManager(viewedContent, pdfDocument, pages),
            downloadManager: new MvDownloadManager(),
            renderForms: false
        });
    });
</script>

<div class="mv-pdf-page-annotations annotation-layer-{page.pageNumber} annotationLayer"
     bind:this={annotationLayerElement}></div>

<style lang="less">
    @import "pdfjs-dist/web/pdf_viewer.css";

    .mv-pdf-page-annotations {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
    }
</style>